import { render } from "./PeerReviewSection.vue?vue&type=template&id=2d3b94a5"
import script from "./PeerReviewSection.vue?vue&type=script&lang=js"
export * from "./PeerReviewSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__